(function () {
  'use strict';

  // Container to store viewer instances
  var viewers = {};

  // Helper functions to ensure viewer id creation logic is consistent.
  function getViewerIdFromContainer ($container) {
    return $container.attr('tablename') + $container.attr('primarykey');
  }

  function getViewerFromTab ($tab) {
    if ($tab.length > 0) {
      var viewerId = getViewerIdFromContainer($('#' + $tab.attr('aria-controls')));
      return viewers[viewerId];
    }
  }

  /**
   * Create a div contaning the VIL and all of its options
   * Still used by Slides.php
   * @param options
   * @param divId
   */
  function createVIL (options, divId) {
    var $container = $('#' + divId);
    $container.addClass('vilDiv').css('overflow', 'hidden');
    $container.append('<div id="pal-web-viewer" />'); // add child to mount viewer to

    // TODO: What is this for?
    if (divId.substring(0, 7) === 'Results') {
      options.displayViewer = false;
    }

    // if user doesn't write access to this case, or the case tab is locked, set options.lockMode,
    // which will lock both the VIL and the DST
    if (options.hasOwnProperty('currentId') &&
      typeof(AlreadyOpenedCases) !== 'undefined' &&
      typeof(AlreadyOpenedCases[options.currentId]) !== 'undefined') {
      options.lockMode = AlreadyOpenedCases[options.currentId].canEdit === 'false' ||
        AlreadyOpenedCases[options.currentId].isLocked;
    }
    // if iDevice, set iosmode
    if (SystemParms.isiDevice) {
      options.iosMode = true;
    }

    // disable initiate Conferencing if user's role does not allow it
    if (false === SystemParms.initiateConferencing) {
      if (!options.uScope.hasOwnProperty('toolbarOptions')) {
        options.uScope.toolbarOptions = {};
      }
      options.uScope.toolbarOptions.dscSetupBtn = false;
    }

    // disable labels in DST and uScope if the system parameter for displaying labels in details pages is false
    if (SystemParms.DisplayLabelsInDetails === false) {
      options.displayLabels = false;
    }

    // pass the current user id to uScopeStart
    options.uScope.setup.userid = SystemParms.UserId;
    options.uScope.setup.userName = SystemParms.FullName || SystemParms.LoginName;
    options.usePAL = isPALMode();

    var viewerId = getViewerIdFromContainer($container.closest('[tablename][primarykey]'));
    window['lbs.pi.webViewer'].default.viewer.create({
      el: '#pal-web-viewer',
      options: {
        bearerToken: SystemParms.AuthToken,
        dataServerPath: SystemParms.DataServerProxyPath,
        imageServerPath: SystemParms.ImageServerProxyPath,
        i18n: {
          lang: options.locale
        }
      },
      legacyConfig: options
    })
      .then(function (viewer) {
        viewers[viewerId] = viewer;
      });
  }

  /**
   * Save the DST if it has been modified
   * @param tab The tab object to search for the vilDiv beneath
   */
  function saveDSTifModified (tab) {
    var viewer = getViewerFromTab(tab);
    if (viewer) {
      viewer.state.maybeSaveDst();
    }
  }

  /**
   * Save the current VIL (if any) state for this tab
   * @param tab The tab object to search for the vilDiv beneath
   */
  function vilSaveState (tab) {
    var viewer = getViewerFromTab(tab);
    if (viewer) {
      viewer.state.save();
    }
  }

  /**
   * Restore the current VIL (if any) state for this tab
   * @param tab The tab object to search for the vilDiv beneath
   */
  function vilRestoreState (tab) {
    var viewer = getViewerFromTab(tab);
    if (viewer) {
      viewer.state.restore();
    }
  }

  /**
   * Save all VILs on all tabs to the database.
   * Called by body's onbeforeunload function
   */
  function saveAllVils () {
    Object.keys(viewers).forEach(function (key) {
      viewers[key].state.save();
    });
  }

  /**
   * Indicate the VIL on the currently selected MainTab needs to be refreshed.
   * It will not actually refresh until the VIL tab is selected
   */
  function refreshVILRequired () {
    var vilInstance = $.getVilInstance();
    if (vilInstance) {
      // the vilSettings data is no longer valid, remove it
      vilInstance.removeData('vilSettings');
      // call VIL function to update the DST and uScope
      vilInstance.refreshVILRequired();
    }
  }

  /**
   * Save DST to the database.
   */
  function saveDst () {
    var vilInstance = $.getVilInstance();
    vilInstance && vilInstance.saveDst();
  }

  function teardownViewer (tab) {
    var viewer = getViewerFromTab(tab);
    if (viewer) {
      viewer.state.teardown();
    }
  }

  window.jsPAL.viewer = {
    createVIL: createVIL,
    saveDSTifModified: saveDSTifModified,
    vilSaveState: vilSaveState,
    vilRestoreState: vilRestoreState,
    saveAllVils: saveAllVils,
    refreshVILRequired: refreshVILRequired,
    saveDst: saveDst,
    teardownViewer: teardownViewer
  };
}());
